import { isInViewport } from './inviewport'

(() => {
    const products = document.querySelector('[data-form-products]')

    if (!products) {
        return
    }

    const check = () => {
        if (!products.classList.contains('form-products--animation') && isInViewport(products)) {
            products.classList.add('form-products--animation')
        }
    }

    check()
    window.addEventListener('scroll', check)

})()
